import type { ReactNode } from "react";
import { Checkbox } from "../checkbox"
import "./input-checkbox-group.css"
import type { Column } from "@/types/array.types";

export type CheckboxOptionType = Column<any>

interface InputCheckboxGroupProps {
    label?: string;
    value: string[];
    options: CheckboxOptionType[];
    onChange: (value: string[]) => void;
}

export const InputCheckboxGroup = ({label, options, value, onChange}: InputCheckboxGroupProps) => {
    return (
    <div className="input-checkbox-group-container">
        {label && <div className="input-checkbox-group-label">{label}</div>}
        <fieldset className="input-checkbox-group-fieldset">
            {options.map((option) => 
                <Checkbox 
                    key={`input-check${option.key}`} 
                    id={option.key} 
                    label={option.label}
                    checked={value.includes(option.key)}
                    onChange={(checked) => {
                        if (checked) {
                            onChange([...value, option.key]);
                        } else {
                            onChange(value.filter(key => key !== option.key));
                        }
        }}
                />)}
        </fieldset>
    </div>
    )

}